<template>
  <btn
    v-if="isBisEnabled"
    modifiers="secondary block center"
    type="button"
    :label="$string('back_in_stock.product_form.cta')"
    @click.prevent="openBis"
  />

  <!-- Back in stock modal -->
  <teleport
    v-if="isBisEnabled"
    to="body"
  >
    <overlay
      key="bisModal"
      type="drawer-modal"
      namespace="bisModal"
      direction="up-down"
      block-class="back-in-stock-modal"
    >
      <template #body="overlay">
        <back-in-stock
          v-if="getComponentVisible('back-in-stock')"
          v-cloak
          :overlay="overlay"
          :product="product"
          :variant="variant"
        />
      </template>
    </overlay>
  </teleport>
</template>

<script>

/**
 * Vue: back-in-stock-btn (back-in-stock-btn)
 * -----------------------------------------------------------------------------
 * A back in stock "notify me" button that triggers the back in stock flow
 *
 */

import { mapActions } from 'vuex'
import { defineAsyncComponent } from 'vue'

import Btn from '~global/btn/btn'
import Overlay from '~global/overlay/overlay'

export default {
  name: 'BackInStockBtn',
  components: {
    BackInStock: defineAsyncComponent({
      loader: () => import(
        /* webpackChunkName: 'component.back-in-stock' */
        '~async/back-in-stock/back-in-stock'
      ),
    }),
    Btn,
    Overlay,
  },

  props: {
    product: {
      type: [Boolean, Object],
      default: false,
    },
    variant: {
      type: [Boolean, Object],
      default: false,
    },
  },

  emits: {
    'missing-variant': () => true,
  },

  computed: {

    /**
     * Compute if bis is enabled
     * Requirements:
     * - Setting is turned on
     * - Product is tagged with back in stock
     * @returns {*}
     */
    isBisEnabled() {
      return this.$variable('settings.bis.enabled') &&
        this.product?.tags?.includes('notify-bis')
    },
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      toggleOverlay: 'overlays/toggle',
    }),

    /**
     * Open back in stock modal
     */
    openBis() {
      if (!this.variant) {
        this.$emit('missing-variant')
        return
      }

      this.toggleOverlay({
        namespace: 'bisModal',
        ignoreDismissed: true,
        component: 'back-in-stock',
      })
    },
  },
}
</script>

<style lang="scss">
@import './back-in-stock-modal';
</style>
